import React, { useEffect, useId } from "react";
import { ThemeWrapper } from "@verity/components";
import { CustomSettingData } from "../../settings-page";
import { CoreSwitch } from "@verity/components/core";
import i18n from "../../../../i18n";

export const InstitutionReportEmailInput = (props: {
	loadData: { enabled: boolean };
	setting: CustomSettingData<boolean>;
	onSettingChange: (value: boolean) => void;
}) => {
	const [enabled, setEnabled] = React.useState(props.setting.value ?? props.loadData.enabled);
	const titleId = useId();

	useEffect(() => {
		props.onSettingChange(enabled);
	}, [enabled, props]);

	return (
		<ThemeWrapper>
			<div style={{ maxWidth: "100%", overflowX: "auto" }}>
				<div style={{ minWidth: "420px" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							fontSize: "15px",
							alignItems: "center",
						}}
					>
						<div>
							<div id={titleId}>
								<b>{i18n.t("portal.components.settings.institutionReportEmailTSX.title")}</b>
							</div>
							{i18n.t("portal.components.settings.institutionReportEmailTSX.description")}
						</div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "8px",
								marginRight: "5px",
							}}
						>
							<CoreSwitch
								checked={enabled}
								onChange={(e) => setEnabled(e.target.checked)}
								labelTextType="left"
								labelOffText={i18n.t("portal.components.settings.institutionReportEmailTSX.notSubscribed")}
								labelOnText={i18n.t("portal.components.settings.institutionReportEmailTSX.subscribed")}
								inputProps={{ "aria-labelledby": titleId }}
							/>
						</div>
					</div>
				</div>
			</div>
		</ThemeWrapper>
	);
};
